import { Flex, Menu, useColorModeValue } from '@chakra-ui/react';
import { FilterHeading } from 'src/components/atoms/FilterHeading';
import { MenuButton } from 'src/components/atoms/MenuButton';
import { MenuOption } from 'src/components/atoms/MenuOption';
import { MenuList } from 'src/components/molecules/MenuList';
import { useSelectedDimensionContext } from 'src/features/MM/contexts/SelectedDimensionContext';
import { Dimension } from 'src/features/MM/types';
import { getDimensionName } from 'src/features/MM/utils/getDimensionName';
import { Icon } from 'src/components/atoms/Icon';
import { MenuTriangle } from 'src/components/atoms/MenuTriangle';

const MENU_BUTTON_NAME = 'dimension-select';

const options: Array<Dimension> = [
  Dimension.campagin,
  Dimension.media,
  Dimension.campaignGroup,
];

const DimensionMenu: React.FC = () => {
  const { dimension, setDimension } = useSelectedDimensionContext();
  const fontActiveColor = useColorModeValue(
    'text.darkBlue.900',
    'text.dark.highContrast',
  );
  return (
    <Menu isLazy>
      {({ isOpen }) => (
        <>
          <MenuButton buttonName={MENU_BUTTON_NAME} color={fontActiveColor}>
            <Icon iconName="database" width={6} height={6} mr={2} />
            {getDimensionName(dimension)}
            <MenuTriangle isOpen={isOpen} />
          </MenuButton>
          <MenuList buttonName={MENU_BUTTON_NAME}>
            {options.map((opt) => (
              <MenuOption
                buttonName={MENU_BUTTON_NAME}
                colorSelected
                key={opt}
                label={getDimensionName(opt)}
                value={opt}
                isSelected={opt === dimension}
                onClick={() => setDimension(opt)}
              />
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export const DimensionSelector: React.FC = () => {
  return (
    <>
      <FilterHeading headingText="Dimension" color="text.darkGray" />
      <Flex
        direction={'row'}
        p="14px"
        borderRadius="lg"
        borderWidth="1px"
        color="text.darkGray"
        fontSize="md"
        fontFamily="marketingPage"
        fontWeight="normal"
        borderColor="border.layout"
        bg="surface.control">
        <DimensionMenu />
      </Flex>
    </>
  );
};
